export function formatLabel(
  raw: string | number | null | undefined,
  overrides?: Record<string, string>,
): string {
  if (raw === null || raw === undefined) return '—'
  const key = String(raw)
  if (overrides && overrides[key]) return overrides[key]
  if (key.length === 0) return key
  const normalized = key.replace(/_/g, ' ').trim()
  if (!normalized) return key
  return normalized.charAt(0).toUpperCase() + normalized.slice(1)
}

// `formatPercent`, `formatNumber`, `formatValue` and `toPercentValue` guessed
// a 0-1 value was a fraction and multiplied it by 100, so a declared 1% printed
// as 100%. They had no callers and were deleted;
// format a figure from its declared unit (`formatAbsoluteScore`).

/**
 * Short display label from a saved brand host (e.g. coca-cola.com → "Coca Cola").
 * Uses the second-level label before the public suffix; not accurate for all ccTLDs (e.g. co.uk).
 */
export function labelFromBrandDomain(domain: string | null | undefined): string | null {
  if (!domain?.trim()) return null
  let host = domain.trim().toLowerCase()
  host = host.replace(/^https?:\/\//, '').split('/')[0] ?? ''
  host = host.replace(/^www\./, '')
  const parts = host.split('.').filter(Boolean)
  if (parts.length === 0) return null
  const sld = parts.length >= 2 ? parts[parts.length - 2]! : parts[0]!
  const words = sld.split(/[-_]+/).filter(Boolean)
  if (words.length === 0) return null
  return words
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ')
}
